import React from "react";
import { Text, Layout, Menu, Space, Tabs, Button, theme, Modal, Tooltip, Badge } from 'antd';
import {
  HistoryOutlined,
  ExclamationCircleOutlined,
  FilePdfOutlined
} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { LAB_COLOR, PRIMARY_COLOR, PRINT_COLOR, SUCCESS_COLOR } from "../../constants/color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlask, faFillDrip } from "@fortawesome/free-solid-svg-icons";
import LabResultsModal from "../lab-latex/LabResultsModal"
import { URL_POND } from "../../constants/urls";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../routes/CustomRoutes";
import { LAB_ORDER_TYPE, POND_STATUS, POND_STATUS_OPTIONS, POND_STATUS_TH } from "../../constants/string";
import { formatComma } from "../../frameworks/Util";
import _ from "lodash";
import { CHEMICAL } from "../../constants/chemical";
import { POST } from "../../frameworks/HttpClient";
import ErrorMessages from "../../common/ErrorMessages";

export default function LabPondList() {
  const [ target, setTarget ] = React.useState(null);
  const tableRef = React.useRef(null);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const navigate = useNavigate();

  const columnChemicalWidth = 60;

  const {
    token: { colorSuccess },
  } = theme.useToken();

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const handleOpenPondProduce = async(id) => {
    try {
      const data = {
        action : 'produce'
      }
      await POST(`${URL_POND.POND_TRANSACTION}${id}/change-state/`, data);
      refreshData();
    } catch (error) {
      setErrorMessage(error.errorMessages)
    }
  }

  const confirm = (title, value) => {
    Modal.confirm({
      title: `เปิดบ่อผลิต - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : PRIMARY_COLOR}} />,
      content: 'คุณต้องการเปิดบ่อเพื่อผลิตใช่หรือไม่ ?',
      okText: 'ยืนยัน',
      cancelText: 'ปิด',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : PRIMARY_COLOR}},
      onOk: async() => {
        await handleOpenPondProduce(value)
        refreshData();
      },
      onConfirm: () => refreshData()
    });
  };

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      fixed: 'left',
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <Tooltip triger='hover' title={original.state !== POND_STATUS.END ? "ส่งผลแล็บ" : "ประวัติการส่งผลแล็บ"}>
              <Badge count={original.lab_order_count}>
              <ColorButton 
                type='primary'
                override={original.state !== POND_STATUS.END ? LAB_COLOR : PRINT_COLOR}
                icon={original.state !== POND_STATUS.END ? <FontAwesomeIcon icon={faFlask}/> : <HistoryOutlined />}
                style={{ marginLeft : 10}}
                onClick={()=> navigate(`${PATH.POND_LAB}/${original.id}/${LAB_ORDER_TYPE.LAB_POND}/`)} 
              />
              </Badge>
            </Tooltip>
            {original.state === POND_STATUS.CLOSED && <Tooltip triger='hover' title={"ผลิต"}>
              <ColorButton
                type='primary'
                override={colorSuccess}
                style={{ marginLeft : 10 }}
                icon={<FontAwesomeIcon icon={faFillDrip} />}
                onClick={() => confirm(original.lot_no, original.id)}
              />
            </Tooltip>}
          </div>
      )}
    },
    {
      title: 'บ่อ',
      dataIndex: 'pond_name',
      key: 'pond_name',
      fixed: 'left',
      searcher: true,
      render : (value) => {
        return value ? value : '-'
      }
    },
    {
      title: 'Lot No.',
      dataIndex: 'lot_no',
      key: 'lot_no',
      fixed: 'left',
      searcher: true,
      render : (value, original) => value ? 
        <>
          {value}
          <Tooltip triger='hover' title='รายละเอียดสต๊อกน้ำยางสด'>
            <Button type='link' icon={<FilePdfOutlined />} onClick={() => window.open(`${window.origin}${PATH.POND_SUMMARY}/${original.id}`)}/>
          </Tooltip>
        </> : '-'
    },
    {
      title: 'น้ำหนัก',
      dataIndex: 'current_weight',
      key: 'current_weight',
      fixed: 'left',
      render : (value) => value ? formatComma(value) : "-"
    },
    {
      title: 'สถานะ',
      dataIndex: 'state',
      key: 'state',
      fixed: 'left',
      searcher: true,
      searcherOptions: POND_STATUS_OPTIONS,
      render : (value) => {
        return value ? POND_STATUS_TH[value] : '-'
      }
    },
    ...CHEMICAL.POND.map((data) => {
      return {
        title : <center>{data.chemical}</center> ,
        dataIndex: data.chemical,
        width: columnChemicalWidth,
        key: data.chemical,
        render : (value, original) => {
          const findData = (_.find(_.get(original, 'lab_results' , []), { 'chemical': _.get(data, 'chemical' , '')} ))
          if(findData){
            return <center>{formatComma(_.get(findData, 'amount' , '-'))}</center>
          } else return <center> - </center>
        }
      }
    })
    
  ]

  React.useEffect(() => {
    const interval = setInterval(() => {
      refreshData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return(
    <>  
      <ErrorMessages message={errorMessage}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_POND.POND_TRANSACTION}
        params={{ type : 'pond', ordering : "state"}}
        scroll={{
          x: 'max-content',
        }}
      />

      <LabResultsModal
        open={target ? true : false}
        onClose={() => {
          setTarget(null)
        }}
        target={target}
        onUpdate={() => {
          setTarget(null)
          refreshData();
        }}
      />
    </>
  )
}